require('intersection-observer')
const path = require('path')
const ventures = require('./ventures')
const { configuration } = require('@albatross/common-components/dist/config')
const { environments, ENV_CATEGORIES } = require('./environments')

const env = process.env.NODE_ENV || 'development'
const isBrowser = typeof window !== 'undefined'
const environment = isBrowser ? window.__ENV__ : process.env.ENV

const venture = isBrowser ? window.__VENTURE__ : process.env.VENTURE

const enableContentful = isBrowser ? window.__ENABLE_CONTENTFUL__ : process.env.ENABLE_CONTENTFUL === 'true'

const config = configuration(venture)

const host = isBrowser
  ? window.location.hostname
  : process.env.HOSTNAME || 'localhost'

const isPPC = environments[environment]?.category === ENV_CATEGORIES.staging
const isLive = environments[environment]?.category === ENV_CATEGORIES.live

const tealiumEnv = isLive ? 'prod' : isPPC ? 'qa' : 'dev'

if ((!venture || venture === 'undefined') && env !== 'test') {
  throw new Error(
    'Error: VENTURE command line option not provided or is undefined'
  )
}

const appVersion = process.env.APP_VERSION || 'v0.0.0'

const tealiumVenture = Object.values(ventures).reduce((obj, venture) => {
  return {
    ...obj,
    [venture.key]: venture.tealiumTag
  }
}, {})

function isRetinaDisplay () {
  if (isBrowser && window.matchMedia) {
    const mq = window.matchMedia(
      'only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)'
    )
    return (mq && mq.matches) || window.devicePixelRatio > 1
  }
  return false
}

const imageScale = isRetinaDisplay() ? 'scale-2' : 'scale-1'

const port = isBrowser ? window.location.port : process.env.PORT || 8080

const breakpoints = [444, 588, 684, 972, 1270]

const apiUrl = isBrowser
  ? window.__API__ || 'http://seo-ci.gamesys.corp:9000'
  : process.env.API || 'http://seo-ci.gamesys.corp:9000'

const restApiUrl = isBrowser
  ? window.__REST_API__ || 'http://seo-ci.gamesys.corp:9000/api/rest'
  : process.env.REST_API || 'http://seo-ci.gamesys.corp:9000/api/rest'

const redisOptionsFromEnv = {
  host: process.env.REDIS_HOST,
  port: process.env.REDIS_PORT,
  password: process.env.REDIS_PASSWORD
}

const redisSentinelPort = 26379
const redisSentinels = [
  {
    host: process.env.NODE_REDIS_SENTINEL_HOST_0,
    port: redisSentinelPort
  },
  {
    host: process.env.NODE_REDIS_SENTINEL_HOST_1,
    port: redisSentinelPort
  },
  {
    host: process.env.NODE_REDIS_SENTINEL_HOST_2,
    port: redisSentinelPort
  }
]

const ppcOptions = redisOptionsFromEnv
const productionOptions = redisOptionsFromEnv

const seoOptions = {
  host: 'seo-ci.gamesys.corp'
}

const localOptions = {
  host: 'localhost'
}
const redisOptions = isLive
  ? productionOptions
  : isPPC
    ? ppcOptions
    : host === 'seo-ci.gamesys.corp'
      ? seoOptions
      : localOptions

const redisSupport = process.env.REDIS_LOCAL_SUPPORT || isPPC || isLive

const baseUrl = ventures[venture]?.urls?.url

const isBeforeLaunchDate = (launchDateTime) => {
  const currentDateUK = Date.now()
  const launchDate = new Date(launchDateTime).getTime()
  return currentDateUK < launchDate
}

const isPreLaunch = (venture) =>
  ventures[venture]?.launchDate &&
  isBeforeLaunchDate(ventures[venture].launchDate)

const pixelSupport = ventures[venture]?.pixelSupport

const extractorProps = !isBrowser
  ? {
      statsFile: path.resolve(
    `./dist/public${config.countryUrl}loadable-stats.json`
      ),
      entrypoints: ['client'],
      publicPath: config.countryUrl
    }
  : undefined

const ventureConfig = ventures[venture]

const handshakeProps = {
  ext: {
    authentication: {
      venture: 'bingo'
    }
  }
}

const cometDConfigOptions = {
  url: 'wss://bingo-connection-proxy.prd00.iedu.ballys.tech:8443/ws/cometd-guest',
  logLevel: 'warn'
}

const subChannel = (channel) => `/bingo/lobby/${channel}`
const pubChannel = (channel) => `/request/player/venture/guest/${channel}`

const cometDConfig = {
  ventureIsSupported: ventures[venture]?.bingoCommetDId,
  handshakeProps,
  options: cometDConfigOptions,
  subChannel: subChannel(ventures[venture]?.bingoCommetDId),
  pubChannel: pubChannel(ventures[venture]?.bingoCommetDId)
}

const isNewHeader = isBrowser ? window.__SHOW_NEW_HEADER__ : process.env.SHOW_NEW_HEADER

module.exports = {
  extractorProps,
  redisOptions,
  redisSentinels,
  redisSupport,
  breakpoints,
  apiUrl,
  restApiUrl,
  basename: '',
  baseUrl,
  env,
  host,
  isBrowser,
  tealiumEnv,
  port,
  venture,
  ventures,
  imageScale,
  tealiumVenture,
  isPPC,
  isLive,
  appVersion,
  isPreLaunch,
  pixelSupport,
  ventureConfig,
  cometDConfig,
  enableContentful,
  isNewHeader,
  ...config
}
